export function focus(
  definition,
  absolutePoint,
  itemViews,
) {
  let focusedItem = null

  function checkItemView(itemView) {
    if (
      !focusedItem &&
      definition.draggableEntities.includes(itemView.entity) &&
      definition.focusDetection(itemView.boundary, {
        x: absolutePoint.x - itemView.boundary.x,
        y: absolutePoint.y - itemView.boundary.y,
      })
    ) {
      itemView.type = 'focused'
      focusedItem = itemView
    } else if (itemView.type === 'focused') itemView.type = 'default'
  }

  const filteredFocusedItem = itemViews.find(itemView => itemView.type === 'focused')
  if (filteredFocusedItem) checkItemView(filteredFocusedItem)

  const filteredItems = itemViews
    .filter(itemView => itemView.type === 'default' && !itemView.deleted)
    .sort((a, b) => a.position - b.position)
  filteredItems.forEach(itemView => checkItemView(itemView))

  //move to up focused item
  if (!focusedItem) return

  let maxPosition = 0
  filteredItems.forEach(item => {
    if (item.position > maxPosition) maxPosition = item.position
  })

  focusedItem.position = maxPosition + 1

  //move to up selected item
  const selectedIndex = itemViews.findIndex(itemView =>
    ['selected', 'resizing', 'dragging'].includes(itemView.type),
  )
  if (selectedIndex === -1) return

  itemViews[selectedIndex].position = maxPosition + 2
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/focus.js